<script setup>
import {onMounted} from "vue";
import {Toast} from "bootstrap";

const props = defineProps({
  id: {type: String, required: true},
  title: {type: String, required: true},
  content: {type: String, required: true},
});

onMounted(() => {
  console.log('CDTToast onMounted')
  const toastElement = document.getElementById(props.id);
  if (toastElement) {
    const bsToast = new Toast(toastElement, {autohide: true, delay: 3000});
    bsToast.show();
  }
});
</script>

<template>
  <div class="position-fixed top-0 end-0 p-5" style="z-index: 1990">
    <div class="toast fade hide mb-3" :id="id" data-autohide="true">
      <div class="toast-header">
        <i class="far fa-bell text-muted me-2"></i>
        <strong class="me-auto">{{ title }}</strong>
        <button type="button" class="btn-close" data-bs-dismiss="toast"></button>
      </div>
      <div class="toast-body">
        {{ content }}
      </div>
    </div>
  </div>
</template>
